export default __webpack_public_path__ + "static/media/companyLogo.68179e47.svg";